(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendation"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function () {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) {
    return;
  }
  var productId = productRecommendationsSection.dataset.productId;
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  var limit = productRecommendationsSection.dataset.limit;
  var requestUrl = baseUrl + "?section_id=product-recommendation&product_id=" + productId + "&limit=" + limit;
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      if ('loading' in HTMLImageElement.prototype) {
        var images = document.querySelectorAll('img[loading="lazy"]');
        var sources = document.querySelectorAll("source[data-srcset]");
        sources.forEach(function (source) {
          source.srcset = source.dataset.srcset;
        });
        images.forEach(function (img) {
          img.src = img.dataset.src;
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
          }
        });
      }
      var eventName = "recommendations:loaded";
      var data = {};
      if (window.CustomEvent && typeof window.CustomEvent === 'function') {
        var event = new CustomEvent(eventName, {detail: data});
      } else {
        var event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, data);
      }
      document.dispatchEvent(event);
    }
  };
  request.send();
};

document.addEventListener("shopify:section:load", function (event) {
  if (event.detail.sectionId === "product-recommendation") {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function () {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) {
    return;
  }
  var productId = productRecommendationsSection.dataset.productId;
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  var limit = productRecommendationsSection.dataset.limit;
  var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      if ('loading' in HTMLImageElement.prototype) {
        var images = document.querySelectorAll('img[loading="lazy"]');
        var sources = document.querySelectorAll("source[data-srcset]");
        sources.forEach(function (source) {
          source.srcset = source.dataset.srcset;
        });
        images.forEach(function (img) {
          img.src = img.dataset.src;
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
          }
        });
      }
      var eventName = "recommendations:loaded";
      var data = {};
      if (window.CustomEvent && typeof window.CustomEvent === 'function') {
        var event = new CustomEvent(eventName, {detail: data});
      } else {
        var event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, data);
      }
      document.dispatchEvent(event);
    }
  };
  request.send();
};

document.addEventListener("shopify:section:load", function (event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
